export const isAcceptInvitationRoute = (pathname: string | null) => pathname?.includes('/accept-invitation') ?? false
